<template>
    <div class="form__item checkbox-container">
        <input
            :id="checkboxId"
            :class="{ error: showError }"
            type="checkbox"
            :name="checkboxName"
            :checked="checked"
            @click="onClick($event.target.checked)"
        >
        <label :for="checkboxName">
            <strong
                class="mr-05"
                :data-test="`checkbox-label-${checkboxName}`"
            >
                {{ label }}
            </strong>
            <span
                :data-test="`checkbox-helper-${checkboxName}`"
            >
                {{ helperText }}
            </span>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'Checkbox',
        props: {
            checkboxId: {
                type: String,
                default: ''
            },
            checkboxName: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            helperText: {
                type: String,
                default: ''
            },
            checked: {
                type: Boolean,
                default: false
            },
            showError: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onClick(checked) {
                this.$emit('update:checked', checked)
                this.$emit('checkboxClicked')
            }
        }
    }
</script>
<style lang="css" scoped src="../../node_modules/@servicensw/form/dist/form.css"></style>
<style lang="scss" scoped>
    .checkbox-container {
        min-height: 50px;
        display: flex;
        align-items: center;

        label {
            display: flex;
            flex-direction: column;
        }
    }
</style>
